import React from 'react'
import Table from '../../components/common/Table'
import { CompetitionResultEntryDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'

interface CompetitionResultEntryTableProps {
  data: CompetitionResultEntryDTO[];
  handleEdit: (row: CompetitionResultEntryDTO) => void;
  handleDelete: (row: CompetitionResultEntryDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const CompetitionResultEntryTable: React.FC<CompetitionResultEntryTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[

        {
          label: "Competition Result Id",
          key: "competitionResultId",
        },

        {
          label: "Competition Exercise Id",
          key: "competitionExerciseId",
        },

        {
          label: "Score Id",
          key: "scoreId",
        },

        {
          label: "Position",
          key: "position",
        },

        {
          label: "Rank",
          key: "rank",
        },

        {
          label: "Added",
          key: "createdUtc",
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },

      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default CompetitionResultEntryTable;
